module.exports = "https://99designs-start-assets.imgix.net/js/acb03c2e52bb0dd93063efe88939a3a7.png";